import { Component, computed, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatientService } from '../../services/patient.service';
import { AppointmentService } from '../../services/appointment.service';
import { BillingService } from '../../services/billing.service';
import { ButtonComponent } from '../ui';

@Component({
  selector: 'app-analytics',
  imports: [CommonModule, ButtonComponent],
  templateUrl: './analytics.component.html',
  styleUrl: './analytics.component.css'
})
export class AnalyticsComponent {
  patients!: Signal<any[]>;
  appointments!: Signal<any[]>;
  bills!: Signal<any[]>;

  constructor(
    private patientService: PatientService,
    private appointmentService: AppointmentService,
    private billingService: BillingService
  ) {
    this.patients = this.patientService.getPatients();
    this.appointments = this.appointmentService.getAppointments();
    this.bills = this.billingService.getBills();
  }

  monthlyRevenue = computed(() => {
    const bills = this.bills();
    const monthlyData: { [key: string]: number } = {};
    
    bills.forEach((bill: any) => {
      if (bill.status === 'Paid') {
        const month = new Date(bill.date).toLocaleString('default', { month: 'short', year: 'numeric' });
        monthlyData[month] = (monthlyData[month] || 0) + bill.total;
      }
    });
    
    return Object.entries(monthlyData).map(([month, revenue]) => ({ month, revenue }));
  });

  appointmentStats = computed(() => {
    const appointments = this.appointments();
    const stats = {
      total: appointments.length,
      scheduled: appointments.filter((a: any) => a.status === 'Scheduled').length,
      confirmed: appointments.filter((a: any) => a.status === 'Confirmed').length,
      completed: appointments.filter((a: any) => a.status === 'Completed').length,
      cancelled: appointments.filter((a: any) => a.status === 'Cancelled').length
    };
    return stats;
  });

  totalRevenue = computed(() => {
    const bills = this.bills();
    return bills
      .filter((b: any) => b.status === 'Paid')
      .reduce((sum: number, b: any) => sum + b.total, 0);
  });

  maxMonthlyRevenue = computed(() => {
    const monthly = this.monthlyRevenue();
    if (monthly.length === 0) return 1;
    return Math.max(...monthly.map((m: any) => m.revenue), 1);
  });

  getRevenuePercentage(revenue: number): number {
    const max = this.maxMonthlyRevenue();
    return max > 0 ? (revenue / max) * 100 : 0;
  }
}

